/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "GetAccountTransferEligibilityRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetAccountTransferEligibilityResponse": {
                "fields": {
                  "ineligibleReasons": {
                    "type": ".squareup.corporate_card.service.GetAccountTransferEligibilityResponse.TransferIneligibleReason",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "TransferIneligibleReason": {
                    "values": {
                      "TIR_DO_NOT_USE": 0,
                      "CREDIT_CARD_APPLICATION_FLOW": 1,
                      "CREDIT_CARD_OPEN": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.GetAccountTransferEligibilityRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.GetAccountTransferEligibilityResponse && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.GetAccountTransferEligibilityResponse?.nested?.TransferIneligibleReason) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetAccountTransferEligibilityRequest @ squareup/corporate_card/service/get_account_transfer_eligibility.proto at 8:1
 */
export const GetAccountTransferEligibilityRequest = $root.lookupType('squareup.corporate_card.service.GetAccountTransferEligibilityRequest');
fixType(GetAccountTransferEligibilityRequest, {
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetAccountTransferEligibilityRequest);
/**
 * SOURCE GetAccountTransferEligibilityResponse @ squareup/corporate_card/service/get_account_transfer_eligibility.proto at 15:1
 */
export const GetAccountTransferEligibilityResponse = $root.lookupType('squareup.corporate_card.service.GetAccountTransferEligibilityResponse');
fixType(GetAccountTransferEligibilityResponse);
Builder.createAndAttachToType(GetAccountTransferEligibilityResponse);
/**
 * SOURCE TransferIneligibleReason @ squareup/corporate_card/service/get_account_transfer_eligibility.proto at 16:3
 */
GetAccountTransferEligibilityResponse.TransferIneligibleReason = $root.lookupEnum('squareup.corporate_card.service.GetAccountTransferEligibilityResponse.TransferIneligibleReason').values;